import { connect } from "react-redux";
import styles from "./index.module.css";
import {
  BoxAssets,
  BoxCourses,
  BoxGroups,
  BoxLicenses,
  BoxReports,
  BoxSessions,
  BoxSessions2,
  BoxSessionsMobile,
  BoxToken,
  BoxUsers,
} from "./boxes/boxes.jsx";
import { useEffect, useState } from "react";
import {
  closeLoading,
  openLoading,
} from "../../components/loadingModal/loading.js";
import { getAllRoles } from "../../actions/manageUsersActions.js";
import { getAllGroups } from "../../actions/manageGroupsActions.js";

const Home = (props) => {
  const {
    user,
    licenses,
    token,
    timer,
    sessions,
    counterGroups,
    counterCourses,
    counterUsers,
    storageInfo,
    reports,
    productsIds,
    has_storage,
    ongoingScheduled,
    courses,
  } = props;
  const mediaQuery = window.matchMedia("(max-width: 427px)");
  const [openModal, setOpenModal] = useState(false);
  const [code, setCode] = useState(false);

  const role = user.role ? user.role : "";
  if (role.toUpperCase() === "ADMIN") {
    if (mediaQuery.matches) {
      return (
        <div>
          <div className={styles.container}>
            <BoxToken
              token={token}
              timer={timer}
              canGenerateTokens
              setOpenModal={setOpenModal}
              openModal={openModal}
              courses={courses}
              setCode={setCode}
            />
            <BoxLicenses licenses={licenses} ready={code} />
            <BoxGroups groups={counterGroups} ready={code} />
            <BoxSessionsMobile sessions={sessions} ready={code} />
          </div>
        </div>
      );
    } else {
      return (
        <div className={styles.container}>
          <div className={styles.containerRow1}>
            <BoxToken
              token={token}
              timer={timer}
              canGenerateTokens
              setOpenModal={setOpenModal}
              openModal={openModal}
              courses={courses}
              setCode={setCode}
            />
            <BoxLicenses licenses={licenses} ready={code} />
            <div className={styles.container1Row2Column}>
              <BoxGroups groups={counterGroups} ready={code} />
              <BoxCourses courses={counterCourses} ready={code} />
            </div>
          </div>
          <div className={styles.containerRow2}>
            <div className={styles.container1Row2Column}>
              <BoxUsers
                totalUsers={counterUsers.total}
                inactiveUsers={counterUsers.inactive}
                activeUsers={counterUsers.active}
                ready={code}
              />
              <BoxSessions sessions={ongoingScheduled} ready={code} />
            </div>
            <BoxReports reports={reports} ready={code} />
            <BoxAssets
              has_storage={has_storage}
              storage={storageInfo}
              mediaQuery={mediaQuery}
              smally={true}
              ready={code}
            />
          </div>
        </div>
      );
    }
  } else if (role.toUpperCase() === "FACULTY") {
    if (mediaQuery.matches) {
      return (
        <div className={styles.containerTwo}>
          <BoxToken
            token={token}
            timer={timer}
            canGenerateTokens
            setOpenModal={setOpenModal}
            openModal={openModal}
            courses={courses}
            setCode={setCode}
          />
          <BoxSessionsMobile sessions={sessions} />
        </div>
      );
    } else {
      return (
        <div className={styles.containerTwo}>
          <div className={styles.containerTwoRow1}>
            <BoxToken
              token={token}
              timer={timer}
              canGenerateTokens
              setOpenModal={setOpenModal}
              openModal={openModal}
              courses={courses}
              setCode={setCode}
            />
            <BoxSessions2 sessions={sessions} ready={code} />
          </div>
          <div className={styles.containerTwoRow2}>
            <div className={styles.container1Row2Column}>
              <BoxGroups isFaculty groups={counterGroups} ready={code} />
              <BoxCourses courses={counterCourses} ready={code} />
            </div>
            <BoxReports reports={reports} ready={code} />
            <BoxAssets
              has_storage={has_storage}
              storage={storageInfo}
              ready={code}
            />
          </div>
        </div>
      );
    }
  } else if (role.toUpperCase() === "LEARNER") {
    return (
      <div className={styles.containerThree}>
        <BoxToken
          token={token}
          timer={timer}
          noProducts={productsIds && productsIds.length === 0 ? true : false}
          canGenerateTokens={false}
          setCode={setCode}
        />
        {!mediaQuery.matches ? (
          <BoxSessions2 sessions={sessions} ready={code} />
        ) : (
          <BoxSessionsMobile sessions={sessions} ready={code} />
        )}
        {!mediaQuery.matches && <BoxReports reports={reports} ready={code} />}
        {!mediaQuery.matches && (
          <BoxAssets
            has_storage={has_storage}
            storage={storageInfo}
            ready={code}
          />
        )}
      </div>
    );
  } else if (role.toUpperCase() === "SCHEDULER") {
    return (
      <div className={styles.containerThree}>
        <BoxToken token={token} timer={timer} setCode={setCode} />
        {!mediaQuery.matches ? (
          <BoxSessions2 sessions={sessions} ready={code} />
        ) : (
          <BoxSessionsMobile sessions={sessions} ready={code} />
        )}
        {/* { !mediaQuery.matches && <BoxReports reports={reports} /> } */}
        {!mediaQuery.matches && <BoxReports reports={reports} ready={code} />}
        {!mediaQuery.matches && (
          <BoxAssets
            has_storage={has_storage}
            storage={storageInfo}
            ready={code}
          />
        )}
      </div>
    );
  } else if (role.toUpperCase() === "TEACHER ASSISTANT") {
    return (
      <div className={styles.containerThree}>
        <BoxToken
          token={token}
          timer={timer}
          canGenerateTokens
          setOpenModal={setOpenModal}
          openModal={openModal}
          courses={courses}
          setCode={setCode}
        />
        {!mediaQuery.matches ? (
          <BoxSessions2 sessions={sessions} />
        ) : (
          <BoxSessionsMobile sessions={sessions} />
        )}
        {!mediaQuery.matches && <BoxReports reports={reports} />}
        {!mediaQuery.matches && (
          <BoxAssets has_storage={has_storage} storage={storageInfo} />
        )}
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    user: state.usersReducer.userLogged,
    productsIds: state.productsReducer.productsIds,
    licenses: state.licenseReducer.totalLicensesActive,
    sessionsNumber: state.manageSessionReducer.ongoingScheduled,
    token: state.manageSessionReducer.tokenSessions.Token,
    timer: state.manageSessionReducer.tokenSessionsTime,
    sessions: state.manageSessionReducer.sessions.upcomingSessions,
    ongoingScheduled: state.manageSessionReducer.ongoingScheduled,
    counterGroups: state.manageGroups.countGroups,
    counterCourses: state.manageCourses.counterCourses,
    counterUsers: state.manageUsers.counterUsers,
    storageInfo: state.assets.storageInfo,
    reports: state.metricIndividualReducer.metricInitialData,
    has_storage: state.usersReducer.userLogged.has_storage,
    groups: state.manageGroups.allGroups,
    courses: state.manageCourses.coursesList,
  };
};

export default connect(mapStateToProps, {
  getAllGroups,
  getAllRoles,
})(Home);
